import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-ab9f9c0e")
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Select Your Label Size", -1)
const _hoisted_3 = { id: "modal-sizes-container" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id", "value", "onInput"]
const _hoisted_6 = ["id", "value", "onInput"]
const _hoisted_7 = ["for"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { id: "size-info" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-body", _ctx.bounceTransition])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", {
            class: "close-svg",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, [
            _createVNode(_component_CloseSVG, { propId: 'sizes-modal-close' })
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labelSizes, (size) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "modal-sizes",
              key: size.label_id,
              id: size.label_id
            }, [
              (size.name === _ctx.currentLabel.label_name)
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    checked: "",
                    name: "labelSizeInput",
                    type: "radio",
                    id: size.name,
                    value: size.name,
                    onInput: ($event: any) => (_ctx.handleInput($event.target, size.label_id))
                  }, null, 40, _hoisted_5))
                : (_openBlock(), _createElementBlock("input", {
                    key: 1,
                    name: "labelSizeInput",
                    type: "radio",
                    id: size.name,
                    value: size.name,
                    onInput: ($event: any) => (_ctx.handleInput($event.target, size.label_id))
                  }, null, 40, _hoisted_6)),
              _createElementVNode("label", {
                for: size.name,
                class: "label-option"
              }, [
                (size.svg_id)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.tryRequire(size)
                    }, null, 8, _hoisted_8))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", null, _toDisplayString(size.name), 1),
                  _createElementVNode("p", null, _toDisplayString(size.label_size), 1)
                ])
              ], 8, _hoisted_7)
            ], 8, _hoisted_4))
          }), 128))
        ]),
        _createElementVNode("button", {
          "aria-label": "Open change label size modal",
          class: "modal-select-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeLabelSize && _ctx.changeLabelSize(...args)))
        }, "Change Label Size")
      ], 2)
    ], 2)
  ]))
}